module.exports = __webpack_public_path__ + "static/media/internet-of-things09.1db4c80b.jpg";